import React, { FC, useState, useEffect } from 'react';
import { UserAuth } from '../../AuthContext';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import Loader from '../Loader/Loader';
import PageLayout from '../Layout/PageLayout';

const PrivateRoute: FC<any> = (props) => {
  const location = useLocation();
  const { pathname } = location;

  const [isLoading, setIsLoading] = useState(
    localStorage.getItem('pokercity.expectSignIn') ? true : false
  );
  useEffect(() => {
    // Add timeout for loader if user is not signed in
    setTimeout(() => {
      setIsLoading(false);
    }, 5000);
  }, []);
  return UserAuth().user ? (
    <Outlet />
  ) : isLoading ? (
    // if user is expected to sign in automatically, display Loading, otherwise redirect to login page.
    <>
      <PageLayout>
        <Loader></Loader>
      </PageLayout>
    </>
  ) : (
    <>
      <Navigate to='/' state={{ path: pathname }}></Navigate>
    </>
  );
};
export default PrivateRoute;
